import BasePriceBinder from './BasePriceBinder';

export default class MultiCheckboxBinder extends BasePriceBinder {
	optionValue;
	optionLabel;

	constructor(
		id,
		title,
		calculator,
		summaryDisplayer,
		priceFormatter,
		optionLabel,
		optionValue
	) {
		super(
			id,
			`${title} (${optionLabel})`,
			calculator,
			summaryDisplayer,
			priceFormatter
		);
		this.optionLabel = optionLabel;
		this.optionValue = optionValue;
		this.optionId = `${this.id}_${optionValue}`;
		this.baseElement = document.getElementById(this.optionId);
		this.isActive = this.baseElement.checked;
	}
	initEvents() {
		this.baseElement.addEventListener('change', (e) => {
			this.isActive = e.target.checked;
			this.handleChange();
		});

		super.initEvents();
	}
}
